import React, {useState, useEffect} from 'react';
import {format, toDate, lightFormat, endOfMonth, getMonth, parseISO} from 'date-fns';
import Select from '../../../../common/Form/Select/Select';
import {DownloadButton} from '../../../../common/Form/Button/Button';
import {endMonth, selectPeriodData, startMonth} from '../ClaimGstModal/mockData';
import calenderIcon from '../../../../common/assets/calenderIcon.png';

import {InvoicePeriodCont, Or} from './InvoicePeriod.styles';
import Info from '../../SubmitGstInput/Info/Info';

const InvoicePeriod = ({
  getGstDataCaller,
  dateObject,
  isMonthChangeFromTable = false,
  startdateString = '2023-04-01',
  resetData,
}) => {
  const [endMonthOptions, setEndMonthOptions] = useState([]);
  const [monthSelected, setMonthSelected] = useState({
    startDate: {},
    endDate: {},
    customSelection: {},
  });
  const [customSelection, setCustomSelection] = useState({});
  const [error, setError] = useState(false);

  useEffect(() => {
    setStartMonhtOptions();
  }, []);

  useEffect(() => {
    if (dateObject?.startDate && dateObject?.endDate && isMonthChangeFromTable) {
      const startString = dateObject?.startDate;
      const startDate = new Date(parseISO(startString, 'yyyy-mm-dd'));
      const endString = dateObject?.endDate;
      const endDate = new Date(parseISO(endString, 'yyyy-mm-dd'));
      const startDateObject = {
        month: startDate?.getMonth(),
        year: startDate?.getFullYear(),
        monthString: `${endMonth[startDate?.getMonth()]}-${startDate?.getFullYear()}`,
      };
      const endDateObject = {
        month: endDate?.getMonth(),
        year: endDate?.getFullYear(),
        monthString: `${endMonth[endDate?.getMonth()]}-${endDate?.getFullYear()}`,
      };
      setMonthSelected({
        startDate: startDateObject,
        endDate: endDateObject,
        customSelection: 'custom',
      });
    }
  }, [dateObject]);

  const isFinancialYearRangeValid = (startDate: any = {}, endDate: any = {}) => {
    // Check if both dates have required properties
    if (!startDate?.year || (!startDate?.month && startDate?.month !== 0) || 
        !endDate?.year || (!endDate?.month && endDate?.month !== 0)) {
      return false;
    }
    
    // Determine financial year for start date
    // Financial year starts in April (month 3) and ends in March (month 2) of next calendar year
    // Months are 0-indexed: 0=Jan, 1=Feb, 2=Mar, 3=Apr, etc.
    const startFY = startDate.month >= 3 ? startDate.year : startDate.year - 1;
    
    // Determine financial year for end date
    const endFY = endDate.month >= 3 ? endDate.year : endDate.year - 1;
    
    // Check if both dates are in the same financial year
    return startFY === endFY;
  }

  useEffect(() => {
    let error = false;
    if (!isMonthChangeFromTable) {
      if (customSelection?.type === 'last_month') {
        getGstDataCaller &&
          getGstDataCaller({
            start_date: customSelection?.startDate,
            end_date: customSelection?.endDate,
          });
      } else if(monthSelected?.startDate?.year && monthSelected?.endDate?.year && !isFinancialYearRangeValid(monthSelected?.startDate, monthSelected?.endDate)) {
        error = true;
        resetData && resetData();
      } else if (monthSelected?.startDate?.year && monthSelected?.endDate?.year) {
        const startMonth = monthSelected?.startDate?.month;
        const startYear = monthSelected?.startDate?.year;
        const startCompleteDate = `${startYear}-${
          startMonth >= 9 ? startMonth + 1 : '0' + (startMonth + 1)
        }-01`;

        const endMonth = monthSelected?.endDate?.month;
        const endYear = monthSelected?.endDate?.year;
        const endDays = new Date(endYear, endMonth + 1, 0).getDate();
        const endCompleteDate = `${endYear}-${
          endMonth >= 9 ? endMonth + 1 : '0' + (endMonth + 1)
        }-${endDays}`;

        const dateObject = {
          start_date: startCompleteDate,
          end_date: endCompleteDate,
        };

        getGstDataCaller && getGstDataCaller(dateObject);
      }
    }
    setError(error);
  }, [monthSelected, customSelection]);

  const handleSelectMonthClick = (value, monthType) => {
    const obj = monthSelected;
    if (monthType === 'start') {
      obj.startDate = value;
    } else if (monthType === 'end') {
      obj.endDate = value;
    } else {
      obj.customSelection = value;
      if (value === 'Last Month') {
        getLastMonth();
      } else if (value === 'hy') {
        //TODO: to be handled later
      } else {
        //TODO: to be handled later
      }
    }
    if (
      obj?.startDate?.year &&
      obj?.endDate?.year &&
      value?.monthString !== 'custom' &&
      value !== 'Last Month'
    ) {
      setCustomSelection({
        monthString: 'custom',
      });
    }
    setMonthSelected({...obj});
  };

  const setStartMonhtOptions = () => {
    const d = new Date();
    const curMonth = d.getMonth() - 1;
    const curYear = d.getFullYear();
    const minMonth = new Date(startdateString).getMonth();
    const minYear = new Date(startdateString).getFullYear();
    const monthColectiveArray = [];

    for (let i = minYear; i <= curYear; i++) {
      if (curYear === minYear) {
        for (let j = minMonth; j <= curMonth; j++) {
          let obj = {
            month: j,
            year: i,
            monthString: `${endMonth[j]} ${i}`,
          };
          monthColectiveArray.push(obj);
        }
      } else {
        const start = i === minYear ? minMonth : 0;
        const end = i === curYear ? curMonth : 11;
        for (let j = start; j <= end; j++) {
          let obj = {
            month: j,
            year: i,
            monthString: `${endMonth[j]} ${i}`,
          };
          monthColectiveArray.push(obj);
        }
      }
    }
    setEndMonthOptions(monthColectiveArray);
  };

  const getLastMonth = () => {
    const d = new Date();
    const obj = monthSelected;
    let customSelectionObject = customSelection;
    const lastMonth = d?.getMonth() - 1 >= 9 ? `${d?.getMonth()}` : `0${d?.getMonth()}`;
    const lastMonthIndex = d?.getMonth() - 1;
    if (d?.getMonth() === 0) {
      const prevYear = d?.getFullYear() - 1;
      const startDate = `${prevYear}-12-01`;
      const endDate = `${prevYear}-12-31`;
      customSelectionObject = {
        startDate,
        endDate,
        type: 'last_month',
        monthString: 'Last Month',
      };
      obj.startDate = {
        month: 11,
        year: prevYear,
        monthString: `${endMonth[11]}-${prevYear}`,
      };
      obj.endDate = {
        month: 11,
        year: prevYear,
        monthString: `${endMonth[11]}-${prevYear}`,
      };
    } else {
      const startDate = `${d?.getFullYear()}-${lastMonth}-01`;
      const endDate = lightFormat(
        endOfMonth(new Date(d?.getFullYear(), d?.getMonth() - 1)),
        'yyyy-MM-dd',
      );
      customSelectionObject = {
        startDate,
        endDate,
        type: 'last_month',
        monthString: 'Last Month',
      };
      obj.startDate = {
        month: lastMonthIndex, //TODO: Handeling for the Dec Month. To be handled in
        year: d?.getFullYear(),
        monthString: `${endMonth[d?.getMonth() - 1]}-${d?.getFullYear()}`,
      };
      obj.endDate = {
        month: lastMonthIndex, //TODO: Handeling for the Dec Month. To be handled in
        year: d?.getFullYear(),
        monthString: `${endMonth[d?.getMonth() - 1]}-${d?.getFullYear()}`,
      };
    }
    setMonthSelected({...obj});
    setCustomSelection({...customSelectionObject});
  };

  return (
    <>
      <InvoicePeriodCont>
        <div>
          <p className="fs14 latoBlack mb8">Select Period</p>
          <Select
            dropdownWidth={'280px'}
            placeholderText="Select Period"
            endIcon={true}
            options={selectPeriodData}
            selectionType="custom"
            onChange={handleSelectMonthClick}
            value={customSelection}
          />
        </div>
        <Or>- OR -</Or>
        <div className="mr15">
          <p className="fs14 latoBlack mb8">Start Month</p>
          <Select
            dropdownWidth={'180px'}
            placeholderText="Select Month"
            startIcon={calenderIcon}
            options={endMonthOptions}
            selectionType="start"
            onChange={handleSelectMonthClick}
            value={monthSelected?.startDate}
          />
        </div>
        <div>
          <p className="fs14 latoBlack mb8">End Month</p>
          <Select
            dropdownWidth={'180px'}
            startIcon={calenderIcon}
            placeholderText="Select Month"
            options={endMonthOptions}
            selectionType="end"
            onChange={handleSelectMonthClick}
            value={monthSelected?.endDate}
          />
        </div>
      </InvoicePeriodCont>
      {error && <Info heading="Please select single financial year for selection." inline={true} width="auto" />}
    </>
  );
};

export default InvoicePeriod;
